export interface IDayJsContext {
	readonly dayjs: any;
}
